import { Component, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MatrizEventosPotService } from '../../../services/operative-potential/matriz-eventos-pot/matriz-eventos-pot.service';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../services/excel/excel.service';

import { FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { FuncionesMes, periodosOperativo } from '../../funciones/funcionesGenerales';
import { potential_event } from '../../funciones/estructuras';
//Se eliminara al implementar los catalogos por administrador
import { Accion, Agencia, Area, Categoria, colores, companies, Control, ControlVal, EfectividadControl, Estatus, EstatusEvento, EstatusPlan, Fuente, Impacto, NivelExpocision, NivelRiesgo, Oportunidad, Perdida, Periodicidad, PERMISOS, Probabilidad, Riesgo } from './../../../shared/catalogos';

import Swal from 'sweetalert2';
import moment from 'moment';
import * as XLSX from 'xlsx'
import { messages } from '../../funciones/mensajes';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-matriz-eventos',
  templateUrl: './matriz-eventos.component.html',
  styleUrl: './matriz-eventos.component.css'
})
export class MatrizEventosComponent {
  public readonly permisos = PERMISOS;

  private idInstitucion = '';
  translate = inject(TranslateService);

  accion;
  tipoRiesgo;
  control;
  efectControl;
  estatus;
  fuente;
  impacto;
  perdida;
  probabilidad;
  riesgo;
  area;
  categorias;
  conceptos = [];
  eventos = [];
  estatusevent;
  periodicidad;
  oportunidad;
  responsable;
  nivelExp = 0;

  progressInfo = [];
  selectedFiles;

  ordenado = 'norm';
  dataOrdenado = [];
  private dataOrdenadoAll = [];
  niveles = 3;

  existSelec = false;
  seleccionados = 0;

  agr = false;
  edi = false;

  private probabilidadVal;
  private impactoVal;
  private controlVal;
  private nivelRiesgo;
  private nivelExpocision;

  validado = ['Validado','Sin validar'];
  itemEdicion;

  step = 0;
  ingresoMontos = true;

  prefix = '';
  suffix = 'MXN';
  miles = ',';
  decimal = '.';
  precicion = 0;
  aling = '';

  Periodos = [];
  Periodos2 = [];
  cadenaEvaluacion = [];
  cadenaEvaluacion2 = [];
  filtroPeriodos = false;

  subTitles = '';
  subTitles2 = '';

  formEvento = new FormGroup({
    event_date: new FormControl('', [Validators.required]),
    area: new FormControl('default', [Validators.required, this.defaultValidation('area')]),
    process: new FormControl('', [Validators.required]),
    risk_type: new FormControl('default', [Validators.required, this.defaultValidation('risk_type')]),
    category: new FormControl('default', [Validators.required, this.defaultValidation('category')]),
    concept: new FormControl('default', [Validators.required, this.defaultValidation('concept')]),
    event: new FormControl('default', [Validators.required, this.defaultValidation('event')]),
    event_detail: new FormControl(''),
    consequence: new FormControl(''),
    source: new FormControl('default', [Validators.required, this.defaultValidation('source')]),
    derived_risk: new FormControl('default', [Validators.required, this.defaultValidation('derived_risk')]),
    loss: new FormControl('default', [Validators.required, this.defaultValidation('loss')]),
    loss_amount: new FormControl('', [Validators.required]),
    transferred_loss: new FormControl('', [Validators.required]),
    impact: new FormControl('default', [Validators.required, this.defaultValidation('impact')]),
    probability: new FormControl('default', [Validators.required, this.defaultValidation('probability')]),
    mitigators: new FormControl(''),
    control_type: new FormControl('default', [Validators.required, this.defaultValidation('control_type')]),
    periodicity: new FormControl('default', [Validators.required, this.defaultValidation('periodicity')]),
    opportunity: new FormControl('default', [Validators.required, this.defaultValidation('opportunity')]),
    control_effectiveness: new FormControl('default', [Validators.required, this.defaultValidation('control_effectiveness')]),
    work_plan: new FormControl(''),
    plan_responsible: new FormControl('default'),
    start_date: new FormControl(''),
    end_date: new FormControl(''),
    plan_status: new FormControl('default')
  },{ validators: this.montoCorrectoValidacion() });

  formSelects = new FormGroup({
    area: new FormControl('default'),
    categoria: new FormControl('default'),
    agencia: new FormControl('default'),
  });
  private defaultValues = {
    event_date: '',
    area: 'default',
    process: '',
    risk_type: 'default',
    category: 'default',
    concept: 'default',
    event: 'default',
    event_detail: '',
    consequence: '',
    source: 'default',
    derived_risk: 'default',
    loss: '',
    loss_amount: '',
    transferred_loss: '',
    impact: 'default',
    probability: 'default',
    mitigators: '',
    control_type: 'default',
    periodicity: 'default',
    opportunity: 'default',
    control_effectiveness: 'default',
    work_plan: '',
    plan_responsible: 'default',
    start_date: '',
    end_date: '',
    plan_status: 'default'
  }

  constructor(
    private cookies: CookieService,
    private services: MatrizEventosPotService,
    public dataService: DataService,
    private exportExcel: ExcelService,
  ){
    this.idInstitucion = this.cookies.get('idInstitucion');
    const ex = companies.find(i => i.id === this.idInstitucion);
    this.suffix = ex.suffix;
    // this.altacatalogos1();
    // this.altacatalogos2();
    this.startCatalogs();
  }

  public setStep(index: number) { this.step = index; }
  public nextStep() { this.step++; }
  public prevStep() { this.step--; }

  private altacatalogos1(){
    Area.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "area",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Riesgo.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "riesgo",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Fuente.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "fuente",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Perdida.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "perdida",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Impacto.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "impacto",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Probabilidad.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "probabilidad",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Control.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "control",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Periodicidad.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "periodicidad",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Oportunidad.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "oportunidad",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    EfectividadControl.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "efectividadcontrol",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    EstatusPlan.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "estatusplan",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    Estatus.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "estatus",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    // Accion.forEach( async (c, i) => {
    //   try{
    //     await firstValueFrom(
    //       this.services.postCatalogos({
    //         institution_id: this.idInstitucion,
    //         type: "accion",
    //         code: i+1,
    //         label: c.name
    //       })
    //     );
    //   }catch(err){
    //     console.log(err)
    //   }
    // });

    // Agencia.forEach( async (c, i) => {
    //   try{
    //     await firstValueFrom(
    //       this.services.postCatalogos({
    //         institution_id: this.idInstitucion,
    //         type: "agencia",
    //         code: i+1,
    //         label: c.name
    //       })
    //     );
    //   }catch(err){
    //     console.log(err)
    //   }
    // });

    EstatusEvento.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "estatusevento",
            code: i+1,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    NivelRiesgo.forEach( async (c, i) =>{
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "nivelriesgo",
            code: i+1,
            label: c.name,
            min: c.min,
            max: c.max,
          })
        );
      }catch(err){
      }
    });

    NivelExpocision.forEach( async (c, i) =>{
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "nivelexpocision",
            code: i+1,
            label: c.name,
            min: c.min,
            max: c.max,
          })
        );
      }catch(err){
      }
    });

    ControlVal.forEach( async (c, i) => {
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "controlval",
            code: c.id,
            label: c.name
          })
        );
      }catch(err){
      }
    });

    colores.forEach( async (c, i) =>{
      try{
        await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "color",
            code: i+1,
            label: c
          })
        );
      }catch(err){
      }
    });
  }
  private altacatalogos2(){
    Categoria.forEach( async (c, i) => {
      try{
        const n1 = await firstValueFrom(
          this.services.postCatalogos({
            institution_id: this.idInstitucion,
            type: "categoria",
            code: i+1,
            label: c.name,
            level: 1,
          })
        );
        c.values.forEach( async (c1, i1) =>{
          try{
            const n2 = await firstValueFrom(
              this.services.postCatalogos({
                institution_id: this.idInstitucion,
                type: n1['id'],
                code: i1+1,
                label: c1.name,
                level: 2,
              })
            );
            c1.values.forEach( async (c2, i2) =>{
              try{
                const n3 = await firstValueFrom(
                  this.services.postCatalogos({
                    institution_id: this.idInstitucion,
                    type: n2['id'],
                    code: i2+1,
                    label: c2.name,
                    level: 3,
                  })
                );
              }catch(err){
              }
            })
          }catch(err){
          }
        })
      }catch(err){
      }
    });
  }

  private async startCatalogs(){
    const catalogos = [
      'area',
      'categoria',
      'accion',
      'riesgo',
      'control',
      'efectividadcontrol',
      'estatus',
      'fuente',
      'impacto',
      'perdida',
      'probabilidad',
      'periodicidad',
      'oportunidad',
      'estatusevento',
      'estatusplan',
      'controlval',
      'nivelriesgo',
      'nivelexpocision',
    ] as const;

    const data = await firstValueFrom(
      forkJoin(
        Object.fromEntries(
          catalogos.map(tipo => [
            tipo,
            this.services.getCatalogos(this.idInstitucion, tipo),
          ]),
        ),
      ),
    );
    this.area = data['area'];
    this.categorias = data['categoria'];
    this.accion = data['accion'];
    this.tipoRiesgo = data['riesgo'];
    this.control = data['control'];
    this.efectControl = data['efectividadcontrol'];
    this.estatus = data['estatus'];
    this.fuente = data['fuente'];
    this.impacto = data['impacto'];
    this.perdida = data['perdida'];
    this.probabilidad = data['probabilidad'];
    this.riesgo = data['riesgo'];
    this.conceptos = [];
    this.eventos = [];
    this.periodicidad = data['periodicidad'];
    this.oportunidad = data['oportunidad'];
    this.estatusevent = data['estatusevento'];
    this.responsable = data['estatusplan'];
    this.impactoVal = data['impacto'];
    this.probabilidadVal = data['probabilidad'];
    this.controlVal = data['controlval'];
    this.nivelRiesgo = data['nivelriesgo'];
    this.nivelExpocision = data['nivelexpocision'];
    this.getData();
  }
  private async getData(){
    this.dataOrdenado = [];
    try {
      const response = await firstValueFrom(
        this.services.getEventos()
      );
      const data = response['data'];
      for(const event of data){
        if(event.institution_id === this.idInstitucion){
          this.dataOrdenado.push({
            institution_id: event.institution_id,
            event_date: moment(event.event_date.split('T')[0]).format("YYYY-MM-DD"),
            area: event.area,
            process: event.process,
            risk_type: event.risk_type,
            category: event.category,
            concept: event.concept,
            event: event.event,
            event_detail: event.event_detail,
            consequence: event.consequence,
            source: event.source,
            derived_risk: event.derived_risk,
            loss: event.loss,
            loss_amount: event.loss_amount,
            transferred_loss: event.transferred_loss,
            net_loss: event.net_loss,
            impact: event.impact,
            probability: event.probability,
            mitigators: event.mitigators,
            control_type: event.control_type,
            periodicity: event.periodicity,
            opportunity: event.opportunity,
            control_effectiveness: event.control_effectiveness,
            work_plan: event.work_plan,
            plan_responsible: event.plan_responsible,
            start_date: event.start_date !== undefined ? moment(event.start_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
            end_date: event.end_date !== undefined ? moment(event.end_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
            plan_status: event.plan_status,
            id: event.id,
          });
        }
      }
      this.dataOrdenadoAll = JSON.parse(JSON.stringify(this.dataOrdenado));
      this.obtPeriodos();
    } catch (error) {
      messages.errorMessageGraph(error.error)
    }
  }
  /* Funcionalidad fechas */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  private obtPeriodos(){
    const iniDate = this.dataOrdenadoAll.map( i => moment(i.event_date) ).sort( (a, b) => a.diff(b))[0];

    const fecha = moment();
    this.Periodos = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1].check = false;
    this.Periodos[0].series[0].check = true;
    this.Periodos2 = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.obtenerDataEvaluacion();
  }
  public cambioPeriodo(per, rango){
    if(rango == 'inicio'){
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
      var check = false, contador = 0, selec2 = 0, posAn = 0, posMes = 0;
      for(let i = 0; i < this.Periodos.length; i++){
        for(let j = 0; j < this.Periodos[i].series.length; j++){
          if(this.Periodos[i].series[j].check || check){
            this.Periodos2[i].series[j].visible = true;
            if(!check){
              posAn = i;
              posMes = j;
            }
            check = true;
          }else{
            this.Periodos2[i].series[j].visible = false;
            this.Periodos2[i].series[j].check = false;
          }
          if(this.Periodos2[i].series[j].visible){
            contador++;
          }
          if(this.Periodos2[i].series[j].check){
            selec2++;
          }
        }
        if(contador == 0){
          this.Periodos2[i].visible = false;
        }else{
          this.Periodos2[i].visible = true;
        }
      }
      if(selec2 === 0){
        this.Periodos2[posAn].series[posMes].check = true;
      }
    }
    if(rango == 'fin'){
      for(const an of this.Periodos2){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
    }

    this.obtenerDataEvaluacion();
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.cadenaEvaluacion2 = [];
    this.subTitles = "";
    this.subTitles2 = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if(this.Periodos[i].series[j].check){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    for(var i = this.Periodos2.length-1; i>=0; i--){
      for(var j = this.Periodos2[i].series.length-1; j>=0; j--){
        if(this.Periodos2[i].series[j].check){
          this.cadenaEvaluacion2.push({
            evaluacion: this.Periodos2[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos2[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos2[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.subTitles2 = this.cadenaEvaluacion2[0].evaluacion;
    var check = false, contador = 0;
    for(let i = 0; i < this.Periodos.length; i++){
      for(let j = 0; j < this.Periodos[i].series.length; j++){
        if(this.Periodos[i].series[j].check || check){
          this.Periodos2[i].series[j].visible = true;
          check = true;
        }else{
          this.Periodos2[i].series[j].visible = false;
        }
        if(this.Periodos2[i].series[j].visible){
          contador++;
        }
      }
      if(contador == 0){
        this.Periodos2[i].visible = false;
      }
    }
    this.selecCategoriaFilter();
  }
  /* */
  public icono(){
    switch(this.ordenado){
      case 'norm':
        return 'file_upload';
      case 'asc':
        return 'file_upload';
      case 'des':
        return 'download';
      default:
        return 'file_upload';
    }
  }
  public ordenar(prop){
    if(this.ordenado === 'norm'){
      this.ordenado = 'asc';
    }else if(this.ordenado === 'asc'){
      this.ordenado = 'des';
    }else if(this.ordenado === 'des'){
      this.ordenado = 'norm';
    }
    this.orden(prop);
  }
  public orden(prop){
    if(this.ordenado === 'asc'){
      this.dataOrdenado.sort(function (a, b) {
        if ( moment(a[''+prop]).isAfter(moment(b[''+prop])) ) {
          return 1;
        }
        if ( moment(a[''+prop]).isBefore(moment(b[''+prop])) ) {
          return -1;
        }
        return 0;
      });
    }else if(this.ordenado === 'des'){
      this.dataOrdenado.sort(function (a, b) {
        if ( moment(a[''+prop]).isBefore(moment(b[''+prop])) ) {
          return 1;
        }
        if ( moment(a[''+prop]).isAfter(moment(b[''+prop])) ) {
          return -1;
        }
        return 0;
      });
    }
  }
  //Se puede guardar o no información
  public puedeGuardar(){
    if( this.formEvento.valid && !this.montoCorrecto() ){
      return ''
    }
    return 'w3-disabled'
  }
  public guardarInfo(estatus){
    if(this.edi){
      this.guardarEditarDato(estatus);
    }else if(this.agr){
      this.guardarDato(estatus);
    }
  }
  public escritura(columna, item){
    switch(columna){
      case 'area':
        return this.area.filter( ar =>  ar.id===Number(item.area) )[0].name;
      case 'riesgo':
        return this.tipoRiesgo.filter( ar =>  ar.id===Number(item.risk_type) )[0].name;
      case 'categoria':
        return this.categorias.filter( ar =>  ar.id===Number(item.category) )[0].name;
      case 'evento':
        const cat = this.categorias.find( ar =>  ar.id===Number(item.category) ).values;
        const con = cat.find( ar =>  ar.id===Number(item.concept) ).values;
        const eve = con.find( ar =>  ar.id===Number(item.event) );
        if(eve)
          return eve.name;
        return '';
      case 'fecha':
        return moment(item.event_date).format("DD-MM-YYYY");
    }
  }
  /* Eventos en tabla */
  public seleccion(elem){
    let cont = 0;
    for(const item of this.dataOrdenado){
      if(item.id === elem.id){
        item.select = !item.select;
      }
      if(item.select){
        cont++;
      }
    }
    this.seleccionados = cont;
    if(cont === 0){
      this.existSelec = false;
    }else{
      this.existSelec = true;
    }
  }
  public agregar(){
    this.agr = true;
    document.getElementById('table').style.display = 'none';
    document.getElementById('form').style.display = 'block';

    var fecha = new Date();
    this.formEvento.controls['event_date'].setValue(moment(fecha).format("YYYY-MM-DD"));
    this.formEvento.controls['loss_amount'].setValue('0');
    this.formEvento.controls['transferred_loss'].setValue('0');
  }
  public async agregarArchivo(){
    let guardo = false,introdujo: any;
     introdujo = await Swal.fire({
      title: ''+ this.translate.instant('operative.matriz-eventos.archivo'),
      text: "",
      input: 'file',
      inputAttributes: {
        "accept": ".xlsx",
        "aria-label": "Upload your profile picture"
      },
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Ingerese un dato valido';
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      messages.messageSaving(this.translate.instant('operative.matriz-eventos.guardando'), this.translate.instant('operative.matriz-eventos.espera'));
      this.progressInfo = [];
      this.selectedFiles = introdujo.value;
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedFiles);
      reader.onload = (e) => {
        let data = reader.result;
        this.obtBuffer(data);
      }
    }
  }
  private async obtBuffer(data){
    const file = await fetch(data)
    const buffer = await file.arrayBuffer().then( async (response) => {
      const workbook = XLSX.read(response);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const raw_data: any = XLSX.utils.sheet_to_json(worksheet, {header: 1});
      let cerro = false;
      for(var i = 0; i < raw_data.length; i++){
        if(raw_data[i].length !== 0 && i !== 0){
          await this.guardarDatoMasivo(raw_data[i]);
        }else if(i !== 0 && i === raw_data.length-1){
          Swal.close();
          messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-agregada'))
          cerro = true;
          break;
        }
      }

      if(!cerro){
        this.selecCategoriaFilter();
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-agregada'));
      }
    });
  }
  private numeroAFecha(numeroDeDias, esExcel = true) {
    var diasDesde1900 = esExcel ? 25567 + 1 : 25567;
    const fecha = new Date((numeroDeDias - diasDesde1900) * 86400 * 1000);
    return moment(fecha).format("YYYY-MM-DD");
  }
  public cerrar(){
    this.agr = false;
    this.edi = false;
    this.step = 0;

    document.getElementById('table').style.display = 'block';
    document.getElementById('form').style.display = 'none';

    this.formEvento.reset(this.defaultValues);
  }
  public async editar(){
    this.edi = true;
    let itemm = undefined;
    for(const item of this.dataOrdenado){
      if(item.select){
        itemm = item;
        this.formEvento.controls['event_date'].setValue(moment(item.event_date).format("YYYY-MM-DD"));
        this.formEvento.controls['area'].setValue(item.area);
        this.formEvento.controls['process'].setValue(item.process);
        this.formEvento.controls['risk_type'].setValue(item.risk_type);
        this.formEvento.controls['category'].setValue(item.category);
        this.selecCategoria();
        this.formEvento.controls['concept'].setValue(item.concept);
        this.selecConcepto();
        this.formEvento.controls['event'].setValue(item.event);
        this.formEvento.controls['source'].setValue(item.source);
        this.formEvento.controls['derived_risk'].setValue(item.derived_risk);
        this.formEvento.controls['loss'].setValue(item.loss);
        this.formEvento.controls['loss_amount'].setValue(item.loss_amount);
        this.formEvento.controls['transferred_loss'].setValue(item.transferred_loss);
        this.formEvento.controls['impact'].setValue(item.impact);
        this.formEvento.controls['probability'].setValue(item.probability);
        this.formEvento.controls['control_type'].setValue(item.control_type);
        this.formEvento.controls['periodicity'].setValue(item.periodicity);
        this.formEvento.controls['opportunity'].setValue(item.opportunity);
        this.formEvento.controls['control_effectiveness'].setValue(item.control_effectiveness);

        this.formEvento.controls['event_detail'].setValue( item.event_detail!==undefined?item.event_detail:'' );
        this.formEvento.controls['consequence'].setValue( item.consequence!==undefined?item.consequence:'' );
        this.formEvento.controls['mitigators'].setValue( item.mitigators!==undefined?item.mitigators:'' );
        this.formEvento.controls['work_plan'].setValue( item.work_plan!==undefined?item.work_plan:'' );
        this.formEvento.controls['plan_responsible'].setValue( item.plan_responsible!==undefined?item.plan_responsible:'default' );
        this.formEvento.controls['start_date'].setValue( item.start_date!==undefined?moment(item.start_date).format("YYYY-MM-DD"):'' );
        this.formEvento.controls['end_date'].setValue( item.end_date!==undefined?moment(item.end_date).format("YYYY-MM-DD"):'' );
        this.formEvento.controls['plan_status'].setValue( item.plan_status!==undefined?item.plan_status:'default' );
        this.ingresoMontosForm();
      }
    }

    if( itemm.event_status === 3 || itemm.event_status === 2 && this.dataService.role === 'Ingresador'){
      const result = await messages.confirmationSave(
        itemm.event_status === 3 ? this.translate.instant('swal.edicionValid') : this.translate.instant('swal.edicionEnValid'),
        this.translate.instant('swal.edicionValidMess'),
        this.translate
      );
      if (result) {
        document.getElementById('table').style.display = 'none';
        document.getElementById('form').style.display = 'block';
      }
    }else if( itemm !== undefined ){
      document.getElementById('table').style.display = 'none';
      document.getElementById('form').style.display = 'block';
    }

  }
  public async copiar(){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.copiando'), this.translate.instant('operative.matriz-eventos.espera'));
    let report= new potential_event();
    for(const item of this.dataOrdenado){
      if(item.select){

        report.institution_id = item.institution_id;
        report.event_date = item.event_date;
        report.area = item.area;
        report.process = item.process;
        report.risk_type = item.risk_type;
        report.category = item.category;
        report.concept = item.concept;
        report.event = item.event;
        report.event_detail = item.event_detail;
        report.consequence = item.consequence;
        report.source = item.source;
        report.derived_risk = item.derived_risk;
        report.loss = item.loss;
        report.loss_amount = item.loss_amount;
        report.transferred_loss = item.transferred_loss;
        report.net_loss = item.net_loss;
        report.impact = item.impact;
        report.probability = item.probability;
        report.mitigators = item.mitigators;
        report.control_type = item.control_type;
        report.periodicity = item.periodicity;
        report.opportunity = item.opportunity;
        report.control_effectiveness = item.control_effectiveness;
        report.work_plan = item.work_plan;
        report.plan_responsible = item.plan_responsible;
        report.start_date = item.start_date;
        report.end_date = item.end_date;
        report.plan_status = item.plan_status;
        item.select = false;
      }
    }
    try {
      const response = await firstValueFrom(
        this.services.postEventos(report)
      );
      const ev = response['data'];
      this.dataOrdenadoAll.push({
        institution_id: ev.institution_id,
        event_date: moment(ev.event_date.split('T')[0]).format("YYYY-MM-DD"),
        area: ev.area,
        process: ev.process,
        risk_type: ev.risk_type,
        category: ev.category,
        concept: ev.concept,
        event: ev.event,
        event_detail: ev.event_detail,
        consequence: ev.consequence,
        source: ev.source,
        derived_risk: ev.derived_risk,
        loss: ev.loss,
        loss_amount: ev.loss_amount,
        transferred_loss: ev.transferred_loss,
        net_loss: ev.net_loss,
        impact: ev.impact,
        probability: ev.probability,
        mitigators: ev.mitigators,
        control_type: ev.control_type,
        periodicity: ev.periodicity,
        opportunity: ev.opportunity,
        control_effectiveness: ev.control_effectiveness,
        work_plan: ev.work_plan,
        plan_responsible: ev.plan_responsible,
        start_date: ev.start_date !== null ? moment(ev.start_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
        end_date: ev.end_date !== null ? moment(ev.end_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
        plan_status: ev.plan_status,
        id: ev.id,
      });
      this.existSelec = false;
      this.selecCategoriaFilter();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-copiada'));
    } catch (error) {
      messages.errorMessageGraph(error.error);
    }
  }
  public async eliminar(){
    const result = await messages.confirmationSave(
      this.translate.instant('operative.matriz-eventos.desea-eliminar'),
      this.translate.instant(''),
      this.translate
    );
    if(result){
      messages.messageSaving(this.translate.instant('operative.matriz-eventos.eliminando'), this.translate.instant('operative.matriz-eventos.espera'));
      let aux = [];
      for(const ev of this.dataOrdenadoAll){
        const ex = this.dataOrdenado.find(e => e.id === ev.id && e.select);
        if(ex){
          try {
            const response = await firstValueFrom(
              this.services.deleteEventos(ev)
            );
          } catch (error) {
            messages.errorMessageGraph(error.error);
            return;
          }
        }else{
          aux.push(ev);
        }
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-eliminada'));
      this.dataOrdenadoAll = [].concat(aux);
      this.selecCategoriaFilter();
      this.existSelec = false;
    }
  }

  /* Agregar info */
  public async guardarDatoMasivo(array){
    let report = new potential_event();

    report.event_date = this.numeroAFecha(array[0]);
    report.area = array[1];
    report.process = array[2];
    report.risk_type = array[3];
    report.category = array[4];
    report.concept = array[5];
    report.event = array[6];
    report.source = array[9];
    report.derived_risk = array[10];
    report.loss = array[11];
    report.loss_amount = array[12]===''&&array[12]===undefined?0:array[12];
    report.transferred_loss = array[13]===''&&array[13]===undefined?0:array[13];
    report.net_loss = array[14]===''&&array[14]===undefined?0:array[14];
    report.impact = array[15];
    report.probability = array[16];
    report.control_type = array[18];
    report.periodicity = array[19];
    report.opportunity = array[20];
    report.control_effectiveness = array[21];

    if(array[7] !== '' && array[7] !== undefined){
      report.event_detail = array[7];
    }
    if(array[8] !== '' && array[8] !== undefined){
      report.consequence = array[8];
    }
    if(array[17] !== '' && array[17] !== undefined){
      report.mitigators = array[17];
    }else{

    }
    if(array[22] !== '' && array[22] !== undefined){
      report.work_plan = array[22];
    }
    if(array[23] !== '' && array[23] !== undefined){
      report.plan_responsible = `${array[23]}`;
    }
    if(array[24] !== '' && array[24] !== undefined){
      report.start_date = this.numeroAFecha(array[24]);
    }
    if(array[25] !== '' && array[25] !== undefined){
      report.end_date = this.numeroAFecha(array[25]);
    }
    if(array[26] !== '' && array[26] !== undefined){
      report.plan_status = array[26];
    }

    report.institution_id = this.idInstitucion;

    try {
      const response = await firstValueFrom(
        this.services.postEventos(report)
      );

      const event = response['data'];
      this.dataOrdenadoAll.push({
        institution_id: event.institution_id,
          event_date: moment(event.event_date.split('T')[0]).format("YYYY-MM-DD"),
          area: event.area,
          process: event.process,
          risk_type: event.risk_type,
          category: event.category,
          concept: event.concept,
          event: event.event,
          event_detail: event.event_detail,
          consequence: event.consequence,
          source: event.source,
          derived_risk: event.derived_risk,
          loss: event.loss,
          loss_amount: event.loss_amount,
          transferred_loss: event.transferred_loss,
          net_loss: event.net_loss,
          impact: event.impact,
          probability: event.probability,
          mitigators: event.mitigators,
          control_type: event.control_type,
          periodicity: event.periodicity,
          opportunity: event.opportunity,
          control_effectiveness: event.control_effectiveness,
          work_plan: event.work_plan,
          plan_responsible: event.plan_responsible,
          start_date: event.start_date !== null ? moment(event.start_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
          end_date: event.end_date !== null ? moment(event.end_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
          plan_status: event.plan_status,
          id: event.id,
      });
    } catch (error) {
      messages.errorMessageGraph(error.error)
      throw new Error(error);
    }
  }
  public async guardarDato(estatus){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.guardando'), this.translate.instant('operative.matriz-eventos.espera'));
    let report = new potential_event();

    report.event_date = moment(this.formEvento.controls['event_date'].value).format("YYYY-MM-DD");
    report.area = this.formEvento.controls['area'].value;
    report.process = this.formEvento.controls['process'].value;
    report.risk_type = this.formEvento.controls['risk_type'].value;
    report.category = this.formEvento.controls['category'].value;
    report.concept = this.formEvento.controls['concept'].value;
    report.event = this.formEvento.controls['event'].value;
    report.source = this.formEvento.controls['source'].value;
    report.derived_risk = this.formEvento.controls['derived_risk'].value;
    report.loss = Number(this.formEvento.controls['loss'].value);
    report.loss_amount = Number(this.formEvento.controls['loss_amount'].value);
    report.transferred_loss = Number(this.formEvento.controls['transferred_loss'].value);
    report.impact = this.formEvento.controls['impact'].value;
    report.probability = this.formEvento.controls['probability'].value;
    report.control_type = this.formEvento.controls['control_type'].value;
    report.periodicity = this.formEvento.controls['periodicity'].value;
    report.opportunity = this.formEvento.controls['opportunity'].value;
    report.control_effectiveness = this.formEvento.controls['control_effectiveness'].value;

    if(this.formEvento.controls['event_detail'].value !== ''){
      report.event_detail = this.formEvento.controls['event_detail'].value;
    }
    if(this.formEvento.controls['consequence'].value !== ''){
      report.consequence = this.formEvento.controls['consequence'].value;
    }
    if(this.formEvento.controls['mitigators'].value !== ''){
      report.mitigators = this.formEvento.controls['mitigators'].value;
    }
    if(this.formEvento.controls['work_plan'].value !== ''){
      report.work_plan = this.formEvento.controls['work_plan'].value;
    }
    if(this.formEvento.controls['plan_responsible'].value !== 'default'){
      report.plan_responsible = this.formEvento.controls['plan_responsible'].value;
    }
    if(this.formEvento.controls['start_date'].value !== ''){
      report.start_date = moment(this.formEvento.controls['start_date'].value).format("YYYY-MM-DD");
    }
    if(this.formEvento.controls['end_date'].value !== ''){
      report.end_date = moment(this.formEvento.controls['end_date'].value).format("YYYY-MM-DD");
    }
    if(this.formEvento.controls['plan_status'].value !== 'default'){
      report.plan_status = this.formEvento.controls['plan_status'].value;
    }

    report.net_loss = Number(report.loss_amount)-Number(report.transferred_loss);
    report.institution_id = this.idInstitucion;

    try {
      const response = await firstValueFrom(
        this.services.postEventos(report)
      );
      const event = response['data'];
      this.dataOrdenadoAll.push({
        institution_id: event.institution_id,
        event_date: event.event_date !== undefined ? moment(event.event_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
        area: event.area,
        process: event.process,
        risk_type: event.risk_type,
        category: event.category,
        concept: event.concept,
        event: event.event,
        event_detail: event.event_detail,
        consequence: event.consequence,
        source: event.source,
        derived_risk: event.derived_risk,
        loss: event.loss,
        loss_amount: event.loss_amount,
        transferred_loss: event.transferred_loss,
        net_loss: event.net_loss,
        impact: event.impact,
        probability: event.probability,
        mitigators: event.mitigators,
        control_type: event.control_type,
        periodicity: event.periodicity,
        opportunity: event.opportunity,
        control_effectiveness: event.control_effectiveness,
        work_plan: event.work_plan,
        plan_responsible: event.plan_responsible,
        start_date: event.start_date !== null ? moment(event.start_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
        end_date: event.end_date !== null ? moment(event.end_date.split('T')[0]).format("YYYY-MM-DD") : undefined,
        plan_status: event.plan_status,
        id: event.id,
      });
      this.selecCategoriaFilter();
      this.cerrar();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-agregada'));
    } catch (error) {
      messages.errorMessageGraph(error)
    }
  }
  public async guardarEditarDato(estatus){
    messages.messageSaving(this.translate.instant('operative.matriz-eventos.editando'), this.translate.instant('operative.matriz-eventos.espera'));
    const sel = this.dataOrdenado.find(e => e.select)
    for(const item of this.dataOrdenadoAll){
      if(item.id === sel.id){
        item.event_date = moment(this.formEvento.controls['event_date'].value).format("YYYY-MM-DD");
        item.area = this.formEvento.controls['area'].value;
        item.process = this.formEvento.controls['process'].value;
        item.risk_type = this.formEvento.controls['risk_type'].value;
        item.category = this.formEvento.controls['category'].value;
        item.concept = this.formEvento.controls['concept'].value;
        item.event = this.formEvento.controls['event'].value;
        item.source = this.formEvento.controls['source'].value;
        item.derived_risk = this.formEvento.controls['derived_risk'].value;
        item.loss = Number(this.formEvento.controls['loss'].value);
        item.loss_amount = Number(this.formEvento.controls['loss_amount'].value);
        item.transferred_loss = Number(this.formEvento.controls['transferred_loss'].value);
        item.impact = this.formEvento.controls['impact'].value;
        item.probability = this.formEvento.controls['probability'].value;
        item.control_type = this.formEvento.controls['control_type'].value;
        item.periodicity = this.formEvento.controls['periodicity'].value;
        item.opportunity = this.formEvento.controls['opportunity'].value;
        item.control_effectiveness = this.formEvento.controls['control_effectiveness'].value;

        if(this.formEvento.controls['event_detail'].value !== ''){
          item.event_detail = this.formEvento.controls['event_detail'].value;
        }
        if(this.formEvento.controls['consequence'].value !== ''){
          item.consequence = this.formEvento.controls['consequence'].value;
        }
        if(this.formEvento.controls['mitigators'].value !== ''){
          item.mitigators = this.formEvento.controls['mitigators'].value;
        }
        if(this.formEvento.controls['work_plan'].value !== ''){
          item.work_plan = this.formEvento.controls['work_plan'].value;
        }
        if(this.formEvento.controls['plan_responsible'].value !== 'default'){
          item.plan_responsible = this.formEvento.controls['plan_responsible'].value;
        }
        if(this.formEvento.controls['start_date'].value !== ''){
          item.start_date = moment(this.formEvento.controls['start_date'].value).format("YYYY-MM-DD");
        }
        if(this.formEvento.controls['end_date'].value !== ''){
          item.end_date = moment(this.formEvento.controls['end_date'].value).format("YYYY-MM-DD");
        }
        if(this.formEvento.controls['plan_status'].value !== 'default'){
          item.plan_status = this.formEvento.controls['plan_status'].value;
        }

        item.net_loss = Number(item.loss_amount)-Number(item.transferred_loss);
        item.institution_id = this.idInstitucion;

        try {
          const response = await firstValueFrom(
            this.services.patchEventos(item)
          );
          item.select = false;
          this.selecCategoriaFilter();
          Swal.close();
          this.existSelec = false;
          messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-editada'));
        } catch (error) {
          if (error.status === 412) {
            messages.succesMessageGraph(this.translate.instant('operative.matriz-eventos.informacion-editada'));
            item.select = false;
            this.selecCategoriaFilter();
            this.existSelec = false;
            break;
          } else {
            messages.errorMessageGraph(error.error);
          }
        }
      }
    }
    this.cerrar();
  }
  public selecCategoria(){
    this.formEvento.controls['concept'].setValue('');
    this.formEvento.controls['event'].setValue('');
    if(this.edi || this.agr){
      const cat = Number(this.formEvento.controls['category'].value);
      const val = this.categorias.filter( c => c.id === cat )[0];
      this.conceptos = [].concat(val.values);
    }
    this.formEvento.controls['concept'].setValue('default');
    this.formEvento.controls['event'].setValue('default');
  }
  public selecConcepto(){
    this.formEvento.controls['event'].setValue('');
    if(this.edi || this.agr){
      if(this.formEvento.controls['concept'].value!=='' && this.formEvento.controls['concept'].value!==null && this.niveles>=3){
        const con = Number(this.formEvento.controls['concept'].value);
        const val2 = this.conceptos.filter( c => c.id === Number(con) )[0];
        this.eventos = [].concat(val2.values);
      }
    }
    this.formEvento.controls['event'].setValue('default');
  }
  public ingresoMontosForm(){
    const dat = Number(this.formEvento.controls['loss'].value);
    const sel = this.perdida.filter(p => p.id === dat);
    if(sel[0].name.toLowerCase() === 'no cuantificable'){
      this.formEvento.controls['loss_amount'].setValue('0');
      this.formEvento.controls['transferred_loss'].setValue('0');
      this.ingresoMontos = false;
    }else{
      this.ingresoMontos = true;
    }
  }
  //Validaciones
  private defaultValidation(control): ValidatorFn {
    return (formGroup: FormGroup) => {
      if(this.agr || this.edi){
        const val = this.formEvento.controls[control].value;
        if(val !== 'default' && val !== '' ){
          return null;
        }
      }
      return {isValid:true};
    };
  }
  private montoCorrectoValidacion(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var valMax = 0, val = 0;
      if(this.agr || this.edi){
        valMax = Number(this.formEvento.controls['loss_amount'].value);
        val = Number(this.formEvento.controls['transferred_loss'].value);
      }
      if(val>valMax) return {isValid:true};
      return null;
    };
  }
  public montoCorrecto():  boolean  {
    return  this.formEvento.hasError('isValid');
  }
  public info(){
    var texto = 'Recuerde llenar todas las secciones para guardar un nuevo evento';
    messages.infoMessageGraph(texto);
  }
  /* Botones */
  public borrarFiltro(){
    this.formSelects.controls['area'].setValue('default');
    this.formSelects.controls['categoria'].setValue('default');

    this.dataOrdenado = [].concat(this.dataOrdenadoAll);
    this.orden('fecha');
  }
  public exportarExcel(){
    var datos = [];

    var encabezados = [
      'Fecha', 'Área', 'Proceso', 'Tipo de riesgo', 'Categoria', 'Concepto', 'Evento', 'Detalle del evento',
      'Consecuencia del riesgo', 'Fuente', 'Riesgo derivado', 'Pérdida', 'Monto de pérdida', 'Pérdida trasladada',
      'Pérdida neta', 'Impacto', 'Probabilidad', 'Mitigantes', 'Tipo de control', 'Periodicidad', 'Oportunidad',
      'Efectividad del control', 'Plan de trabajo', 'Responsable del plan', 'Fecha de inicio', 'Fecha de finalización'
    ];

    for(const i of this.dataOrdenado){
      var aux = [];
      aux.push(moment(i['event_date']).format('DD/MM/YYYY'));
      aux.push(this.area.find(ar => ar.id == i['area']).name);
      aux.push(i['process']);
      aux.push(this.tipoRiesgo.find(c => c.id == i['risk_type']).name);
      var cat = this.categorias.find(c => c.id == i['category']);
      aux.push(cat.name);
      var con = cat.values.find(c => c.id == i['concept']);
      aux.push(con.name);
      var eve = con.values.find(c => c.id == i['event']);
      aux.push(eve? eve.name : '');
      aux.push(i['event_detail']);
      aux.push(i['consequence']);
      aux.push(this.fuente.find( c => c.id == i['source']).name);
      aux.push(this.riesgo.find(c => c.id == i['derived_risk']).name);
      aux.push(this.perdida.find(c => c.id == i['loss']).name);
      aux.push(Number(i['loss_amount']));
      aux.push(Number(i['transferred_loss']));
      aux.push(Number(i['net_loss']));
      aux.push(this.impacto.find(c => c.id == i['impact']).name);
      aux.push(this.probabilidad.find(c => c.id == i['probability']).name);
      aux.push(i['mitigators']);
      aux.push(this.control.find(c => c.id == i['control_type']).name);
      aux.push(this.periodicidad.find(c => c.id == i['periodicity']).name);
      aux.push(this.oportunidad.find(c => c.id == i['opportunity']).name);
      aux.push(this.efectControl.find(c => c.id == i['control_effectiveness']).name);
      aux.push(i['work_plan']);
      var res = this.estatusevent.find(c => c.id == i['plan_responsible']);
      aux.push( res === undefined ? undefined : res.name );
      if(i['start_date'] !== undefined){
        aux.push(moment(i['start_date']).format('DD/MM/YYYY'));
      }else{
        aux.push(undefined);
      }
      if(i['end_date'] !== undefined){
        aux.push(moment(i['end_date']).format('DD/MM/YYYY'));
      }else{
        aux.push(undefined);
      }
      datos.push(aux);
    }

    let tituloHoja = this.translate.instant('operative-potential.matriz-eventos.titulo-principal');
    this.exportExcel.generateEventosPot(tituloHoja, encabezados, datos, tituloHoja);
  }
  /* Filtros */
  public selecCategoriaFilter(){
    let ar = this.formSelects.controls['area'].value;
    let ct = this.formSelects.controls['categoria'].value;

    let aux = [];
    if(ar !== 'default'){
      let existentes = [];
      existentes = this.dataOrdenadoAll.filter(rep => Number(rep.area) === Number(ar));
      aux = [].concat(existentes);
    }
    if(ct !== 'default'){
      let existentes = [];
      if(aux.length !== 0 || ar !== 'default'){
        existentes = aux.filter(rep => Number(rep.category) === Number(ct));
      }else{
        existentes = this.dataOrdenadoAll.filter(rep => Number(rep.category) === Number(ct));
      }
      aux = [].concat(existentes);
    }
    if(ar === 'default' && ct === 'default'){
      aux = [].concat(this.dataOrdenadoAll);
    }

    if(this.filtroPeriodos){
      let aux2 = [];
      const fechaIni = moment(this.cadenaEvaluacion[0].periodo+'-01');
      const fechaFin = moment(this.cadenaEvaluacion2[0].periodo+'-28');
      for(const dat of aux){
        const f = moment(dat.event_date).format("YYYY-MM-DD");
        if(periodosOperativo.validacionPeriodo(moment(dat.event_date),fechaIni,fechaFin)){
          aux2.push(dat);
        }
      }
      aux = [].concat(aux2);
    }

    this.dataOrdenado = [].concat(aux);
    this.orden('fecha');
  }
  public activacionFiltros(){
    this.filtroPeriodos = !this.filtroPeriodos;
    this.selecCategoriaFilter();
  }
}
